export default "__VITE_ASSET__CzcU0weA__"